import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e091f2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gutter-y-s3 list-placeholder" }
const _hoisted_2 = { class: "list-placeholder-item flex flex-column xl:flex-row justify-content-between xl:align-items-center" }
const _hoisted_3 = { class: "w-full xl:w-15rem sm:flex xl:block" }
const _hoisted_4 = { class: "flex flex-wrap flex-grow-1" }
const _hoisted_5 = { class: "flex flex-wrap gutter-y-s3 flex-grow-1 xl:justify-content-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-full xl:w-9rem h-1rem sm:h-auto" }, null, -1))

import { useStore } from 'vuex';
import Caption from '@/components/Caption.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListLoadingPlaceholder',
  props: {
    captions: null,
    firstColClass: null,
    count: null
  },
  setup(__props: any) {

const props = __props as {
  captions: { caption: string; tooltip?: string; colClass?: string }[];
  firstColClass?: string;
  count?: number | string;
}

const { state } = useStore();



const colWidth = computed(() => `sm:w-${Math.floor(12 / props.captions.length)}`);
const counter = computed(() => +(props.count ?? 3));

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(counter), (n) => {
      return (_openBlock(), _createElementBlock("div", { key: n }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Skeleton, {
              height: "22px",
              width: "142px"
            })
          ]),
          (!_unref(state).layout.isDesktop)
            ? (_openBlock(), _createBlock(_component_Divider, {
                key: 0,
                class: "panel-collapse-divider border-secondary"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.captions, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(`w-12 ${item.colClass ?? _unref(colWidth)}`),
                  key: item.caption
                }, [
                  _createVNode(Caption, {
                    caption: item.caption,
                    tooltip: item?.tooltip
                  }, null, 8, ["caption", "tooltip"]),
                  _createVNode(_component_Skeleton, {
                    width: "120px",
                    height: "20px",
                    class: "mt-s1"
                  })
                ], 2))
              }), 128))
            ]),
            _hoisted_6
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})